import { normalizeActingVariantId } from "./characterAssetPaths";

type DialogueThumbnailVariantInput = {
  text: string;
  actingVariantId?: string | undefined;
};

const SHOCKED_TERMS = [
  "まさか",
  "そんな",
  "信じられ",
  "息を呑",
  "青ざめ",
  "震え",
  "叫",
  "驚",
  "悲鳴",
] as const;

const CONFRONTED_TERMS = [
  "なぜ",
  "証拠",
  "矛盾",
  "犯人",
  "罪",
  "真相",
  "問い詰",
  "追及",
  "暴",
  "白状",
] as const;

const SUSPICIOUS_TERMS = [
  "沈黙",
  "隠",
  "嘘",
  "疑",
  "目を逸",
  "口ごも",
  "ためら",
  "怪しい",
  "妙だ",
  "不自然",
] as const;

function includesAny(text: string, terms: readonly string[]): boolean {
  return terms.some((term) => text.includes(term));
}

export function resolveDialogueThumbnailVariantId(
  segment: DialogueThumbnailVariantInput,
): string {
  const explicit = normalizeActingVariantId(segment.actingVariantId);
  if (explicit !== null) return explicit;

  const text = segment.text.trim();
  if (includesAny(text, SHOCKED_TERMS)) return "shocked";
  if (includesAny(text, CONFRONTED_TERMS)) return "confronted";
  if (includesAny(text, SUSPICIOUS_TERMS)) return "suspicious";
  return "neutral";
}
